import React from 'react'
import Text from 'react-text'
import {Link} from 'react-router-dom'
import Griddle, {plugins, RowDefinition, ColumnDefinition} from 'griddle-react'
import {Context} from '../../../context'
import {bind} from '../../../helpers/utils'
import ContextLoader from '../../context-loader'
import SearchPattern from '../../search-pattern'
import UploadLesson from './upload'
import components from './columns'
import Filter from './filters'
import {Pagination, PageDropdown} from '../../pagination'

import './index.styl'

const {columns, headers} = components

const Layout = ({Table, Pagination, Filter}) => (
  <div className="my-lessons-search-table">
    <div className="head">
      <Filter />
      <Pagination />
    </div>
    <Table />
  </div>
)

function NoResults (props) {
  return (
    <div className={props.className}>
      <Text id="my-lessons_search_no_results_label" />
    </div>
  )
}

export default class MyLessons extends React.Component {
  static contextType = Context

  constructor(props) {
    super(props)
    bind(this, 'goPage', 'goNext', 'goPrevious', 'sort')
  }

  goPage (page) {
    this.context.navigate({}, this.context.match.params, {preserveQuery: true, query:{page}})
  }

  goNext () {
    this.goPage(this.context.myLessons[0].currentPage + 1)
  }

  goPrevious () {
    this.goPage(this.context.myLessons[0].currentPage - 1)
  }

  sort ({id, sortAscending}) {
    const orderBy = `${sortAscending ? '' : '-'}${id}`
    this.context.navigate({}, this.context.match.params, {preserveQuery: true, query:{orderBy}})
  }

  render () {
    const context = this.context 
    const [pageProperties, ...lessons] = context.myLessons
    const {recordCount} = pageProperties || {}
    return (
      <ContextLoader id="myLessons" className="my-lessons">
        <div className="wrapper">
          <div className="header">
            <UploadLesson />
            <div style={{flexGrow: 1}} />
            <SearchPattern initialPattern={context.query.pattern} />
          </div>
          <div className="my-lessons-search-results">
            <Griddle
              data={lessons}
              components={{
                NoResults,
                PageDropdown,
                Pagination,
                Layout,
                Filter
              }}
              pageProperties={pageProperties}
              events={{
                onNext: this.goNext,
                onPrevious: this.goPrevious,
                onGetPage: this.goPage,
                onSort: this.sort
              }}
            >
             <RowDefinition>
               <ColumnDefinition
                 id='name'
                 customHeadingComponent={headers.MyLessonsHeader}
                 customComponent={columns.UploadColumn}
               />
               <ColumnDefinition
                 id='subjectName'
                 customHeadingComponent={headers.MyLessonsHeader}
               />
               <ColumnDefinition
                 id='gradeName'
                 customHeadingComponent={headers.MyLessonsHeader}
               />
               <ColumnDefinition
                 id='byteLength'
                 customHeadingComponent={headers.MyLessonsHeader}
                 customComponent={columns.ByteLengthColumn}
               />
               <ColumnDefinition
                 id='modified'
                 customHeadingComponent={headers.MyLessonsHeader}
                 customComponent={columns.DateColumn}
               />
               <ColumnDefinition
                 id='links'
                 customHeadingComponent={headers.EmptyHeader}
                 customComponent={columns.LessonLinksColumn}
               />
             </RowDefinition>
            </Griddle>
          </div>
      </div>
    </ContextLoader>)
  }
}
